import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from '../components/ScrollReveal';
export function AboutPage() {
  return <div className="w-full pt-32 pb-24 px-6 md:px-12" data-id="element-89">
      <div className="max-w-7xl mx-auto" data-id="element-90">
        {/* About Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center mb-32" data-id="element-91">
          <ScrollReveal direction="right" data-id="element-92">
            <h1 className="text-5xl md:text-7xl font-heading font-bold text-teal leading-tight mb-8" data-id="element-93">
              A strategic approach to creative work.
            </h1>
            <div className="w-20 h-1 bg-coral mb-8" data-id="element-94" />
          </ScrollReveal>

          <ScrollReveal delay={0.2} direction="left" data-id="element-95">
            <div className="space-y-6 text-lg text-teal/80 leading-relaxed" data-id="element-96">
              <p data-id="element-97">
                Fore River Creative Co. was founded by Lauren Rabideau with the
                goal of helping businesses show up online in a way that feels
                intentional, elevated, and effective.
              </p>
              <p data-id="element-98">
                Growing up alongside the rapid evolution of social media, Lauren
                developed a deep understanding of digital trends, content
                strategy, and audience behavior—turning that insight into a
                results-driven creative approach.
              </p>
              <p data-id="element-99">
                Today, Fore River Creative Co. partners with brands to create
                content that not only reflects who they are, but drives real
                engagement and growth.
              </p>
            </div>
          </ScrollReveal>
        </div>

        {/* Team Section */}
        <div className="bg-white/40 rounded-[3rem] p-8 md:p-16 border border-white/60" data-id="element-100">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-101">
            <div className="lg:col-span-5" data-id="element-102">
              <ScrollReveal data-id="element-103">
                <div className="aspect-[4/5] rounded-[2rem] bg-sage relative overflow-hidden shadow-xl" data-id="element-104">
                  {/* Headshot Placeholder */}
                  <img src="https://imagizer.imageshack.com/v2/640x480q70/924/nmRmLC.png" alt="Lauren Rabideau — Founder & Lead Creator" className="absolute inset-0 w-full h-full object-cover" data-id="element-105" />
                </div>
              </ScrollReveal>
            </div>

            <div className="lg:col-span-7" data-id="element-106">
              <ScrollReveal delay={0.2} data-id="element-107">
                <h2 className="text-4xl md:text-5xl font-heading font-bold text-teal mb-2" data-id="element-108">
                  Lauren Rabideau
                </h2>
                <h3 className="text-xl text-coral font-medium mb-8" data-id="element-109">
                  Founder & Lead Creator
                </h3>

                <p className="text-lg text-teal/80 leading-relaxed mb-8" data-id="element-110">
                  Lauren leads every project with a focus on strategy,
                  creativity, and execution. With a background in content
                  creation, marketing, and brand development, she works closely
                  with clients to bring their vision to life while ensuring
                  every detail aligns with business goals.
                </p>

                <a href="mailto:Lauren@Forerivercreativeco.com" className="inline-flex items-center gap-2 text-teal font-bold hover:text-coral transition-colors border-b-2 border-teal hover:border-coral pb-1" data-id="element-111">
                  Lauren@Forerivercreativeco.com
                </a>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </div>;
}